<script setup lang="ts">
import { computed, ref, watch } from 'vue'

import type { IconStyleType, ImpactType } from '@/api/interfaces'
import type { ComparisonType } from '@/stores/interfaces/PublicData'

interface Props {
  iconStyle: IconStyleType
  comparisonType: ComparisonType
  impactType: ImpactType
}

const props = defineProps<Props>()

const svgLoaders = import.meta.glob('/src/assets/images/icons/**/*.svg', {
  import: 'default',
}) as Record<string, () => Promise<string>>

const svgKey = computed(() => {
  return `/src/assets/images/icons/${props.iconStyle}/${props.impactType}/${props.comparisonType}.svg`
})
const iconUrl = ref<string | undefined>(undefined)

watch(
  svgKey,
  async (key) => {
    const loader = svgLoaders[key]
    iconUrl.value = loader ? await loader() : undefined
  },
  { immediate: true },
)

const toReadable = (s: string) => s.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/[-_]/g, ' ')

const altText = computed(() => {
  return `${toReadable(props.comparisonType)} icon`
})
</script>

<template>
  <img v-if="iconUrl" :src="iconUrl" :alt="altText" />
</template>

<style scoped lang="scss"></style>
